export default __webpack_public_path__ + "static/uk_mob_banner-23b57de8c431662c243fc11873889f94.webp";